(() => {
  const menus = [...document.querySelectorAll('[data-house-nav-details]')];
  if (!menus.length) return;
  const close = (menu, restoreFocus = false) => {
    menu.removeAttribute('open');
    if (restoreFocus) menu.querySelector('summary')?.focus();
  };
  for (const menu of menus) {
    menu.addEventListener('toggle', () => {
      if (menu.open) for (const other of menus) if (other !== menu) close(other);
    });
    menu.addEventListener('keydown', event => {
      if (event.key === 'Escape' && menu.open) {
        event.preventDefault();
        close(menu, true);
      }
    });
    menu.addEventListener('focusout', event => {
      if (event.relatedTarget && !menu.contains(event.relatedTarget)) close(menu);
    });
    menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => close(menu)));
  }
  document.addEventListener('pointerdown', event => {
    for (const menu of menus) if (!menu.contains(event.target)) close(menu);
  });
})();
